import { render, staticRenderFns } from "./VEmployerCompany.vue?vue&type=template&id=309f07ad&lang=pug"
import script from "./VEmployerCompany.vue?vue&type=script&lang=ts"
export * from "./VEmployerCompany.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerCompany.vue?vue&type=style&index=0&id=309f07ad&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmployerCompany.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fpages%2FLayout%2Fviews%2FEmployer%2Fviews%2FCompany%2FVEmployerCompany.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports